var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.discount > 0 && !_vm.hidePrices
    ? _c(
        "span",
        {
          staticClass: "sale-flash",
          class: {
            "sale-flash--big": _vm.saleType == "article",
            "sale-flash--big product-teaser--big__sale-flash":
              _vm.saleType == "big-teaser"
          }
        },
        [_vm._v("\n  -" + _vm._s(_vm.discount) + "%\n")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-795946fc", { render: render, staticRenderFns: staticRenderFns })
  }
}